__turbopack_context__.v({
  "card": "cert-prep-module-scss-module__Hn6CUq__card",
  "card-description": "cert-prep-module-scss-module__Hn6CUq__card-description",
  "cards": "cert-prep-module-scss-module__Hn6CUq__cards",
  "cert-prep": "cert-prep-module-scss-module__Hn6CUq__cert-prep",
  "heading": "cert-prep-module-scss-module__Hn6CUq__heading",
  "layout": "cert-prep-module-scss-module__Hn6CUq__layout",
  "sidebar": "cert-prep-module-scss-module__Hn6CUq__sidebar",
  "sidebar-content": "cert-prep-module-scss-module__Hn6CUq__sidebar-content",
  "subtitle": "cert-prep-module-scss-module__Hn6CUq__subtitle",
});
